export default (axios, baseURL) => async (params, clientSid, batchId, email, selectedCsvTypes) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/zip/${encodeURIComponent(batchId)}/hub-upload`;

  const axiosConfig = {
    method: 'PATCH',
    baseURL,
    url,
    params,
    data: {
      notificationEmail: email,
      csvTypes: selectedCsvTypes
    }
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
